import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { Elements, StripeProvider } from 'react-stripe-elements';
import { connect } from 'react-redux';

import { selectUrlToFonts, selectLocale } from '../../selectors/client';

import PaymentForm from './PaymentForm';

import { splitLocale } from '../../lib/locale-utils';
import { selectStripe } from '../../selectors/stripe';
import LoadingIndicator from '../common/LoadingIndicator';
class StripePaymentForm extends PureComponent {
  static propTypes = {
    language: PropTypes.string.isRequired,
    urlToFonts: PropTypes.string.isRequired,
    stripe: PropTypes.object,
  };

  render() {
    if (!this.props.stripe) {
      return <LoadingIndicator isLoading />;
    }

    const { language, urlToFonts, stripe, ...rest } = this.props;
    return (
      <StripeProvider stripe={stripe}>
        <Elements
          locale={language}
          fonts={[
            {
              family: 'Eesti Display',
              src: urlToFonts,
            },
          ]}
        >
          <PaymentForm {...rest} />
        </Elements>
      </StripeProvider>
    );
  }
}

function mapStateToProps(state) {
  return {
    urlToFonts: selectUrlToFonts(state),
    language: splitLocale(selectLocale(state)).language,
    stripe: selectStripe(state),
  };
}

export default connect(mapStateToProps, {})(StripePaymentForm);
